import React, { Component } from 'react';
import { Divider } from 'antd';
import { Link } from 'react-router-dom';
import cnb2 from './assets/cnb2.png'
import S from './sty.module.less';

class Footer extends Component {
  render() {
    return (
      <footer className={`main ${S.footer}`}>
        <div>
          ©武汉有教文化传播有限公司 版权所有
          <Divider type='vertical' />
          <span>地 址：武汉东湖新技术开发区华师园路5号武汉华中师大科技园发展有限公司办公楼2栋204</span>
          <Divider type='vertical' />
          <Link to='/about'><span>关于有教</span></Link>
          
        </div>
        
        <div>
          <a rel="noopener noreferrer" target='_blank' href='http://jbts.mct.gov.cn/12318/'>
            12318全国文化市场举报网站
          </a>
          <Divider type='vertical' />
          <a rel="noopener noreferrer" target='_blank' href='http://www.12377.cn/'>
            中国互联网不良信息举报中心
          </a>
          <Divider type='vertical' />
          <span>客服举报电话：027-87860070</span>
        </div>

        <div>
          <Link to='/rules/platform'><span>永播直播平台管理规范</span></Link>
          <Divider type='vertical' />
          <Link to='/rules/minor'><span>未成年人主播管理规定</span></Link>
          <Divider type='vertical' />
          <Link to='/rules/anchor'><span>主播管理行为规范</span></Link>
          <Divider type='vertical' />
        </div>

        <div>
          <span>网 址：https://www.kzmooc.com</span>
          <Divider type='vertical' />
          <span>
            <img
              alt=''
              width="20"
              height="20"
              src={cnb2}
              style={{ marginRight: 3, verticalAlign: 'text-top' }}
            />
            备案号: 鄂ICP备19003195号-1
          </span>
        </div>
      </footer>
    );
  }
}

export default Footer;
